// src/admin/AdminLayout.js
import React, { useContext } from "react";
import { Outlet } from "react-router-dom";
import { AdminLanguageProvider } from "./context/AdminLanguageContext";
import { AdminLanguageContext } from "./context/AdminLanguageContext";

function LayoutContent() {
  const { lang } = useContext(AdminLanguageContext);

  return (
    <div
      id="admin-root"
      className={`
        pt-[56px]
        ${lang === "AR" ? "lg:pr-[240px]" : ""}
      `}
    >
      <Outlet />
    </div>
  );
}

function AdminLayout() {
  return (
    <AdminLanguageProvider>
      <LayoutContent />
    </AdminLanguageProvider>
  );
}

export default AdminLayout;
